import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import App from './App';
import { AuthProvider } from 'src/context/auth/context';
import { ServiceProvider } from 'src/context/services/context';
import { CartProvider } from 'src/context/cart/context';
import { RatesProvider } from './context/RatesContext';

ReactDOM.render(
  <React.StrictMode>
    <AuthProvider>
      <ServiceProvider>
        <CartProvider>
          <RatesProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </RatesProvider>
        </CartProvider>
      </ServiceProvider>
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorker.register();
